import React, { useEffect, useState, useRef } from "react";
import { machineProfile } from "../../api/index.js";
import { toast } from "react-toastify";
import {
  dateToToday,
  formatDateOnly,
  generateLocationToArray,
  printLocation,
} from "../../utils/helper.jsx";
import LiveComparison from "../sensor/live-comparison";
import { useDashboardContext } from "../../contexts/NewDashboardContext";
import { useAuth } from "../../contexts/AuthContext";
import { Card, CardBody } from "../../components/card/card";
import NormalSelect from "../../components/form/HorizontalNormalSelect";

function MachineList() {
  function setupLocationValues(locationSeq, location) {
    locationSeq.push(location.id);
    if (location.parent_location) {
      setupLocationValues(locationSeq, location.parent_location);
    }
  }
  const [datas, setDatas] = useState([]);
  const [filteredMachine, setFilteredMachine] = useState([]);
  const [selectedMachine, setSelectedMachine] = useState(null);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState({ company: true });
  const { getLocationName, email } = useAuth();
  const { locations } = useDashboardContext();
  const [locationValue, setLocationValue] = useState([]);
  const [sublocations, setSublocations] = useState([]);
  useEffect(() => {
    // setSublocations([locations]);
    getMachine();
  }, [locations]);
  async function getMachine() {
    try {
      if (email === "admin_cp@groundup.ai") {
        setSelectedMachine('e007477b-a666-4c6a-b63e-aa0031f0c00b');
        return;
      }
      setLoading(true);
      const queryParam = {
        ...query,
      };
      const res = await machineProfile.list(queryParam);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data) {
          data.forEach((d) => {
            const locationNameArr = [];
            generateLocationToArray(d.location, locationNameArr);
            d.location_arr = locationNameArr.reverse();
          });
          setDatas(data);

          //insert default data
          if (data.length) {
            const oneMachine = data[0];
            const location_v = [];
            const sublocation_v = [];
            if (oneMachine.location) {
              location_v.push(oneMachine.location.id);
            }
            if (oneMachine.location?.parent_location) {
              location_v.push(oneMachine.location?.parent_location?.id);
            }
            if (oneMachine.location?.parent_location?.parent_location) {
              location_v.push(
                oneMachine.location?.parent_location?.parent_location?.id
              );
            }
            setLocationValue(location_v);
            const reverse = location_v.reverse();
            sublocation_v.push(locations);

            const find = locations.find((loc) => loc.id === reverse[0]);
            if (find) {
              sublocation_v.push(find.sublocations);
            }
            let find2 = null;
            if (find) {
              find2 = find.sublocations?.find((loc) => loc.id === reverse[1]);
              if (find2) {
                sublocation_v.push(find2.sublocations);
              }
            }
            // e007477b-a666-4c6a-b63e-aa0031f0c00b
            setSublocations(sublocation_v);
            if (email === "admin_cp@groundup.ai") {
              setSelectedMachine('e007477b-a666-4c6a-b63e-aa0031f0c00b');
            } else {
              setSelectedMachine(oneMachine.id);
            }
          }
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  }
  const handleLocationChange = (e, index) => {
    const location_values = [...locationValue];
    location_values.splice(index);
    location_values.push(e.target.value);
    setLocationValue(location_values);
  };
  useEffect(() => {
    let sublocations = locations;
    const copy = [sublocations];

    const findSublocation = (lv, index) => {
      const location = sublocations.find((l) => l.id == lv);

      if (
        location &&
        location.sublocations &&
        location.sublocations.length > 0
      ) {
        copy.splice(index + 1);
        copy.push(location.sublocations);
        sublocations = location.sublocations;
      } else {
        copy.splice(index + 1);
      }
    };

    console.log({ datas, locationValue })

    if (locationValue.length > 0) {
      locationValue.forEach((lv, index) => {
        findSublocation(lv, index);
      });
      setSublocations(copy);
      // filter machine basedon on Selected last locationValue
      const filtered = datas.filter((d) => {
        return d.location_id == locationValue[locationValue.length - 1];
      });
      if (filtered.length) {

        setFilteredMachine(filtered);
      } else {
        setFilteredMachine(datas)
      }
    }
  }, [locationValue]);

  const changeMachine = (e) => {
    setSelectedMachine(null);
    setTimeout(() => {

      if (email === "admin_cp@groundup.ai") {
        setSelectedMachine('e007477b-a666-4c6a-b63e-aa0031f0c00b');
      } else {
        setSelectedMachine(e.target.value)
      }
    }, 400)
  }

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-12 col-md-12">
          {email !== "admin_cp@groundup.ai" ? (
            <Card>
              <CardBody>
                {sublocations.map((sublocation, index) => {
                  console.log({ sublocation });
                  return (
                    <NormalSelect
                      key={index}
                      required={true}
                      value={locationValue[index]}
                      label={getLocationName(index)}
                      onchange={(e) => handleLocationChange(e, index)}
                      list={sublocation}
                      name={`id`}
                      textKey="location_name"
                      renderFn={printLocation}
                    />
                  );
                })}
                <NormalSelect
                  required={true}
                  value={selectedMachine}
                  label={"Machine"}
                  onchange={changeMachine}
                  list={filteredMachine}
                  name={`id`}
                  valueKey="id"
                  textKey={"machine_name"}
                />
              </CardBody>
            </Card>
          ) : null}
          <div style={{ marginTop: "10px" }}>
            {selectedMachine ? (
              <LiveComparison machineId={selectedMachine}></LiveComparison>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MachineList;
